// src/components/SEOHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = "Torque Energy - Premium Energy Drinks for Peak Performance",
  description = "Torque Energy delivers clean, sustained energy without the crash. Premium energy drinks crafted with natural ingredients to fuel your ambition, enhance focus, and boost performance. Drive Your Day!",
  keywords = "energy drinks, torque energy, clean energy, performance drinks, natural energy, focus boost, sustained energy, no crash, premium energy drinks",
  ogImage = "/logo512.png",
  url = "https://torqueenergy.shop/"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHelmet;
